import { FC, memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/buttons';
import { TCardMode } from '@/modules/game/types';

import { ScShowAllGameCard } from './styled';

interface IShowAllGameCardProps {
  mode: TCardMode;
  to?: string;
  isShowAll?: boolean;
  isShowMoreMode?: boolean;
  isSmall?: boolean;
  onClick?: () => void;
}

export const ShowAllGameCard: FC<IShowAllGameCardProps> = memo(
  ({ mode, isShowAll, to, isShowMoreMode, isSmall = false, onClick }) => {
    const { t } = useTranslation('common');

    const btnTitle = useMemo(() => {
      if (isShowAll) return t('button.showAll');
      if (isShowMoreMode) {
        return isSmall ? t('showMore') : t('showMoreShort');
      }
      return t('showLess');
    }, [isShowAll, isShowMoreMode, isSmall, t]);

    return (
      <ScShowAllGameCard className={mode} mode={mode} isSmall={isSmall}>
        <Button
          blackTransparent={mode === 'light'}
          whiteTransparent={mode === 'dark'}
          small
          wide
          to={to}
          onClick={onClick}
        >
          {btnTitle}
        </Button>
      </ScShowAllGameCard>
    );
  }
);
